module.exports = __webpack_public_path__ + "img/sw-ys11.271d68a8.jpg";